import { Popover, PopoverContent, PopoverTrigger, } from "@/components/ui/popover"
import { format } from "date-fns"
import { Info } from "lucide-react"
import { ContactEvaluationItems } from "./evaluationItems"


export function ContactEvaluationInfo({ contact, items }: { contact?: Contact, items: { [index: string]: Evaluation_Item } }) {

  if (!contact) return null

  const evals = Object.entries(contact.evaluation || {})
  evals.sort((a, b) => b[1].count - a[1].count)

  return <div className="flex gap-2 items-center">

    {contact.severity > 0 && <div className="text-center mx-2">
      <div className="text-xs uppercase text-muted-foreground">Severity</div>
      <div className="font-bold text-lg text-red-500">{contact.severity}</div>
    </div>}

    <ContactEvaluationItems contact={contact} items={items} />

    {contact.summary && <div>
      <Popover>
        <PopoverTrigger asChild>
          <div title="Summary">
            <Info className="size-5 cursor-pointer text-stone-500" />
          </div>
        </PopoverTrigger>
        <PopoverContent align="center" className="max-h-[50vh] w-[25vw] bg-slate-100 mr-12 shadow-lg border-slate-400">
          <div className="w-full overflow-y-auto max-h-[45vh]">
            {contact.lasteval && <div className="text-xs text-muted-foreground pl-2 mb-4">Last Evaluation: {format(contact.lasteval, "MM-dd-yyyy HH:mm")}</div>}
            {contact.summary}
          </div>
        </PopoverContent>
      </Popover>
    </div>}
  </div>

}
